// import { createStore } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./features/authSlice"
import sidebarReducer from "./features/sidebarSlice";
import miscReducer from "./features/miscSlice";
import { dashboardApi } from "./services/dashBoardApi";
import { ordersApi } from "./services/ordersApi";
import { authApi } from "./services/authApi";
import { usersApi } from "./services/usersApi";

// const store = createStore(allReducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())
const store = configureStore({
    reducer: {
        auth: authReducer,
        sidebar: sidebarReducer,
        misc: miscReducer,
        [dashboardApi.reducerPath]: dashboardApi.reducer,
        [ordersApi.reducerPath]: ordersApi.reducer,
        [authApi.reducerPath]: authApi.reducer,
        [usersApi.reducerPath]: usersApi.reducer,
    },
    devTools: true,
    middleware: (getDefaultMiddleware) => 
        getDefaultMiddleware().concat(dashboardApi.middleware, authApi.middleware, ordersApi.middleware, usersApi.middleware)
})

export default store